<div class="search-widget">
    <h2>{{"startPage.search" | translate}}</h2>
    <div c-search-box></div>
</div>